<p-dialog
  class="confidence-score-dialog"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [header]="'confidenceModal.title' | translate"
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
>
  <div class="confidence-modal-content">
    <div class="confidence-score-section">
      <div class="section-label">{{ 'confidenceModal.score' | translate }}</div>
      <div
        class="score-display"
        [ngClass]="getConfidenceClass()"
      >
        <span class="score-value">{{ confidencePercentage | number: '1.0-0' }}%</span>
      </div>
    </div>

    <div class="explanation-section">
      <div class="section-label">{{ 'confidenceModal.explanation' | translate }}</div>
      <p class="explanation-text">{{ customExplanation }}</p>
    </div>

    @if (fieldsNeedingAttention > 0 && confidencePercentage > 0) {
      <div class="fields-attention-section">
        <div class="section-label">
          {{ 'confidenceModal.fieldsNeedingAttention' | translate }}
        </div>
        <div class="attention-display">
          <i class="warning-icon fa-solid fa-triangle-exclamation"></i>
          <span class="attention-count">{{ fieldsNeedingAttention }}</span>
          <span class="attention-text">{{ 'confidenceModal.fieldsNeedReview' | translate }}</span>
        </div>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button
      class="dap-close-confidence"
      severity="secondary"
      [label]="'close' | translate"
      [attr.aria-label]="'close' | translate"
      (click)="close()"
    ></p-button>
  </ng-template>
</p-dialog>
